import type { PublicSiteId } from './publicSite'

export const SUPER_USER = 50
export const ADMIN = 45
export const OWNER = 40
export const COMPANY_MANAGER = 30
export const MANAGEMENT_COMPANY_MANAGER = 25
export const AREA_MANAGER = 20
export const MANAGER = 10
export const ASSISTANT_MANAGER = 5

export interface Roles {
  [key: number]: string
}

export const storageWalkRoles: Roles = {
  [SUPER_USER]: 'Super User',
  [ADMIN]: 'Admin',
  [OWNER]: 'Owner',
  [COMPANY_MANAGER]: 'Company Manager',
  [MANAGEMENT_COMPANY_MANAGER]: 'Management Company Manager',
  [AREA_MANAGER]: 'Area Manager',
  [MANAGER]: 'Manager',
  [ASSISTANT_MANAGER]: 'Assistant Manager',
}

export const patrolWalkRoles: Roles = {
  [SUPER_USER]: 'Super User',
  [ADMIN]: 'Admin',
  [OWNER]: 'Owner',
  [COMPANY_MANAGER]: 'Operations Manager',
  [MANAGEMENT_COMPANY_MANAGER]: 'Security Company Manager',
  [AREA_MANAGER]: 'Patrol Area Manager',
  [MANAGER]: 'Patrol Field Supervisor',
  [ASSISTANT_MANAGER]: 'Patrol Officer',
}

export const constructionWalkRoles: Roles = {
  [SUPER_USER]: 'Super User',
  [ADMIN]: 'Admin',
  [OWNER]: 'Owner',
  [COMPANY_MANAGER]: 'Project Manager',
  [MANAGEMENT_COMPANY_MANAGER]: 'Construction Company Manager',
  [AREA_MANAGER]: 'Site Manager',
  [MANAGER]: 'Site Supervisor',
  [ASSISTANT_MANAGER]: 'Site Inspector',
}

/** @deprecated Prefer getRoles(siteId) or useRoles() for brand-aware titles. */
export const roles: Roles = storageWalkRoles

export function getRoles(siteId: PublicSiteId = 'default'): Roles {
  switch (siteId) {
    case 'security-walk':
      return patrolWalkRoles
    case 'construction-walk':
      return constructionWalkRoles
    default:
      return storageWalkRoles
  }
}
